module.exports = __webpack_public_path__ + "img/type_2.5f576f70.png";